import { useSyncExternalStore } from 'react';

const query = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null);

/** True when the OS asks for less motion. Used for motion CSS can't switch off (SVG animation). */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = query();
      mq?.addEventListener('change', cb);
      return () => mq?.removeEventListener('change', cb);
    },
    () => query()?.matches ?? false,
    () => false,
  );
}
